module.exports = __webpack_public_path__ + "static/media/attach.1c146c70.svg";